/**
 * @file Input.js
 * @version 1.2.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2025-09-21
 * @modified 2026-10-01
 */

import React from 'react';
import './Input.css';
import { onEnterKey } from '../utils/enterKey';

// `step` is intentionally discarded for type="number" inputs: it would reject
// 4dp values (e.g. 0.3812) as :invalid now that Xero unitdp=4 is enabled
// system-wide, and we don't want the browser's native step UI either.
// The accidental-wheel-scroll problem is already handled globally at
// client/src/index.js by blurring focused number inputs on wheel.
//
// `onEnter` runs on Enter. A search box searches as you type, after a pause,
// and Enter is what people press when they want it NOW — or when the results
// look stale. It did nothing, because the boxes sit in no <form>, so the one
// reliable way to re-run a search was to delete and retype a character. Not
// fired while an IME is composing (Enter there picks the candidate), and not
// when the caller's own onKeyDown has already handled the key — the check is
// utils/enterKey.js, shared with the search boxes that are plain <input>s.
function Input({ type = 'text', placeholder, value, onChange, icon, step, onEnter, onKeyDown, ...props }) {
  const enter = onEnter ? onEnterKey(onEnter) : null;
  const handleKeyDown = (enter || onKeyDown) ? (e) => {
    if (onKeyDown) onKeyDown(e);
    if (enter) enter(e);
  } : undefined;
  return (
    <div className="input-wrapper">
      {icon && <span className="material-symbols-rounded input-icon">{icon}</span>}
      <input
        type={type}
        className="styled-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        {...props}
      />
    </div>
  );
}

export default Input;